import { useState } from "react";

import { Callout } from "@/components/ui/callout";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogInner,
  DialogTitle,
} from "@/components/ui/dialog";
import { MainProgram, MiniProgram, NewProgram } from "@/types/programs";

import { AddProgramForm } from "./AddProgramForm";

interface AddProgramsDialogProps {
  open: boolean;
  afterAddedProgram: (program: NewProgram) => void;
  onClose: () => void;
  mode: "create" | "clone";
  selectedProgram?: MainProgram | MiniProgram;
}

export function AddProgramsDialog({
  open,
  afterAddedProgram,
  onClose,
  mode,
  selectedProgram,
}: AddProgramsDialogProps) {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {`${mode === "create" ? "New" : "Clone"} Program`}
          </DialogTitle>
        </DialogHeader>
        <DialogInner>
          {errorMessage && (
            <Callout variant="error" icon={null}>
              {errorMessage}
            </Callout>
          )}

          <AddProgramForm
            onError={(err) => {
              setErrorMessage(err.message);
            }}
            onComplete={(program) => {
              if (program) {
                afterAddedProgram(program);
              }
            }}
            mode={mode}
            selectedProgram={selectedProgram}
          />
        </DialogInner>
      </DialogContent>
    </Dialog>
  );
}
